/**
 * The viewer's timezone, as the backend's date-time contract requires.
 *
 * Every endpoint that buckets by day -- getvisitors, count, cards, bar, the
 * CSV/XLS/PDF exports and the websocket -- now takes `tz` and does its
 * day-boundary arithmetic in that zone. Without it the server falls back to
 * its own, which is how "today" used to mean Qatar's today for a viewer in
 * India.
 *
 * It must be an IANA name (`Asia/Karachi`). An abbreviation like `PKT` or a
 * fixed offset like `+05:00` is rejected: neither carries the DST rules the
 * server needs to find a local midnight.
 *
 * Two viewers in different zones will legitimately see different card numbers
 * at the same moment -- each one's "today" starts at their own midnight.
 */
export const FALLBACK_TIME_ZONE = 'Asia/Qatar';

export function viewerTimeZone() {
  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    // Some older WebViews resolve this to undefined or to an empty string
    // rather than throwing.
    return tz || FALLBACK_TIME_ZONE;
  } catch (e) {
    return FALLBACK_TIME_ZONE;
  }
}

/** Ready to concatenate into a query string. */
export function tzParam() {
  return `tz=${encodeURIComponent(viewerTimeZone())}`;
}

export default viewerTimeZone;
